"use client"
/* */
class Search {
  list;
  render;
  textFieldProps;
  onUpdateCallbacks = /* @__PURE__ */ new Set();
  defaultValue;
  constructor(list, searchShape) {
    this.list = list;
    this.render = searchShape.render;
    this.textFieldProps = searchShape.textFieldProps;
    this.defaultValue = searchShape.defaultValue;
  }
  get value() {
    return this.list.reactTable.searchString;
  }
  get isSet() {
    return this.value !== void 0;
  }
  callOnUpdateCallbacks() {
    this.onUpdateCallbacks.forEach((cb) => cb());
  }
  updateInitialState(initialState) {
    initialState.globalFilter = this.defaultValue;
  }
  setValue(value) {
    if (value === void 0 || value.trim() === "") {
      if (this.list.reactTable.table.getState().globalFilter) {
        this.list.reactTable.table.setGlobalFilter(void 0);
        this.callOnUpdateCallbacks();
      }
    } else {
      this.list.reactTable.table.setGlobalFilter(value);
      this.callOnUpdateCallbacks();
    }
  }
  clear() {
    this.setValue(void 0);
  }
  onUpdated(cb) {
    this.onUpdateCallbacks.add(cb);
  }
}

export { Search };
//# sourceMappingURL=Search.mjs.map
